import React, { useEffect, useState } from 'react'
import "./Home.scss"
// import Avenger from "../../Avengers4.jpg"
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaPlay } from "react-icons/fa";
import { AiOutlinePlus } from "react-icons/ai";
const apikey = "115ac8034a406b1015e392c0fd0935e0";
const url = "https://api.themoviedb.org/3";
const imgUrl = "https://image.tmdb.org/t/p/original";
const upcoming = "upcoming";
const popular = "popular";
const nowPlaying = "now_playing";
const topRated = "top_rated";

// https://image.tmdb.org/t/p/original/wwemzKWzjKYJFfCeiB57q3r4Bcm.svg
// https://api.themoviedb.org/3/movie/550?api_key=115ac8034a406b1015e392c0fd0935e0

const Card = ({ img }) => {
    return (
        <img className='card' src={img} alt="img" />
    )
}

const Row = ({ title, arr = [], }) => {
    return (
        <div className='row'>
            <h2>{title}</h2>
            <div>
                {
                    // console.log(poster_path);
                    arr.map((item, index) => (
                        <Card key={index} img={`${imgUrl}/${item.poster_path}`} />
                    ))
                }
            </div>
        </div>
    )
}

const Home = () => {
    const [upcomingMovies, setUpcomingMovies] = useState([]);
    const [PopularMovies, setPopularMovies] = useState([]);
    const [now_playingMovies, setnow_playingMovies] = useState([]);
    const [topRatedMovies, setTopRatedMovies] = useState([]);
    const [movie_genre, setmovie_genre] = useState([]);

    useEffect(() => {
        const fetchUpcoming = async () => {

            const { data: { results } } = await axios.get(`${url}/movie/${upcoming}?api_key=${apikey}`);
            setUpcomingMovies(results);
        };
        const fetchPopular = async () => {
            const { data: { results } } = await axios.get(`${url}/movie/${popular}?api_key=${apikey}`);
            setPopularMovies(results);
        };
        const fetchNowplaying = async () => {

            const { data: { results } } = await axios.get(`${url}/movie/${nowPlaying}?api_key=${apikey}`);
            setnow_playingMovies(results);

        };
        const fetchToprated = async () => {

            const { data: { results } } = await axios.get(`${url}/movie/${topRated}?api_key=${apikey}`);
            setTopRatedMovies(results);
            console.log(results)
        };
        const getallgenre = async () => {
            const {
                data: { genres },
            } = await axios.get(`${url}/genre/movie/list?api_key=${apikey}`);
            setmovie_genre(genres);
        };
        fetchUpcoming();
        fetchPopular();
        fetchNowplaying();
        fetchToprated();
        getallgenre();
    }, [])

    return (
        <section className='home'>

            <div className="banner" style=
                {{
                    backgroundImage: PopularMovies[7] ? `url(${`${imgUrl}/${PopularMovies[7].poster_path}`})` : "rgb(16,16,16)"
                }}>
                    {PopularMovies[7] && <h1> {PopularMovies[7].original_title}</h1>}
                    {PopularMovies[7] && <p> {PopularMovies[7].overview}</p>}
                    <div>
                    <button className='btn'><FaPlay /> Play</button>
                    <button className='btn'> My List <AiOutlinePlus /></button>
                    </div>
                </div>

            <Row className="row" title={"Upcoming Movies"} arr={upcomingMovies} />
            <Row className="row" title={"Popular on Netflix"} arr={PopularMovies} />
            <Row className="row" title={"Now Playing"} arr={now_playingMovies} />
            <Row className="row" title={"Top-Rated Movies"} arr={topRatedMovies} />
            {/* <Row className="row" title={"My List"} arr = {upcomingMovies} /> */}

            <div className="genrebox">
                {
                    movie_genre.map((item) => (
                        <Link to={`/genre/${item.id}`}>{item.name}</Link>
                    ))
                }
            </div>
        </section>

    )
}

export default Home;
